import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = () => {
  return useQuery(['elearning-feedback'], async () => {
    const response = await service.get(`/progress/feedback`);
    return response.data.data;
  });
};

export default useHook;
